'use client';

import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import styles from './ProfessionalPacks.module.css';
import { HashLink as Link } from 'react-router-hash-link';
import basedGetUrlRequestLogedIn from '../../util/apiRequests/basedGetUrlRequestLogedIn';

export default function ProfessionalPacks() {
  const intl = useIntl();
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPacks = async () => {
      try {
        const response = await basedGetUrlRequestLogedIn('/api/listings-with-pack');
        if (response) {
          setPacks(response.data);
        }
      } catch (error) {
        console.error('Error fetching packs:', error);
        setPacks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPacks();
  }, []);

  const createSlug = title => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .trim();
  };

  const getProductUrl = item => {
    const slug = createSlug(item.title);
    return `/es/l/${slug}/${item.id}`;
  };

  if (loading) {
    return (
      <div className={styles.container}>
        {intl.formatMessage({ id: 'professionalPacks.loadingPacks' })}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {intl.formatMessage({ id: 'professionalPacks.explorePacks' })}
      </h2>
      <div className={styles.scrollContainer}>
        {/* Pack Vlogger */}
        {packs.map(({ listings, pack }, index) => (
          <Link smooth to={'/s#' + intl.formatMessage({ id: `packs.${pack.type}.name` })}>
            <div className={styles.card} key={index}>
              <div className={styles.productSectionGredients}>
                <h3 className={styles.cardTitle}>
                  {intl.formatMessage({ id: `packs.${pack.type}.name` })}
                  {/* {intl.formatMessage({ id: 'professionalPacks.alreadyAvailable' })} */}
                </h3>
                <div className={styles.productSection}>
                  {listings?.map((item, i) => (
                    <div className={styles.product} key={i}>
                      <Link to={getProductUrl(item)}>
                        <img src={item.image} alt={item.image} className={styles.image} />
                      </Link>
                      <Link to={getProductUrl(item)} className={styles.productName}>
                        <span>{item.title}</span>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>

              <div className={styles.infoRow}>
                <div>
                  <h3 className={styles.cardSubTitle}>
                    {intl.formatMessage({ id: `packs.${pack.type}.name` })}
                  </h3>
                  <p className={styles.description}>
                    {intl.formatMessage({ id: `packs.${pack.type}.desc` })}
                  </p>
                </div>
                <button className={styles.button}>
                  <Link smooth to={'/s#' + intl.formatMessage({ id: `packs.${pack.type}.name` })}>
                    {intl.formatMessage({ id: 'professionalPacks.rentPack' })}
                  </Link>
                </button>{' '}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
